import { defaultThemeVariables } from "./defaultThemeVariables";

export const DEFAULT_THEME = {
  name: "default_theme",
  value: 1,
  cssVariables: defaultThemeVariables,
  isCustom: false,
} as const;
